import { AxiosError } from "axios";
import { UseQueryOptions, useQuery } from "react-query";
import { IRole, Route } from "@edgetier/watchtower-types";
import { getAllPaginatedItems } from "utilities/get-all-paginated-items";

/**
 * Request all roles
 * @param url  Route URL
 */
const getRoles = async (url: string) => {
    const roles = await getAllPaginatedItems<IRole>(url);
    return roles.sort((roleOne, roleTwo) => roleOne.role.localeCompare(roleTwo.role));
};

/**
 * Get all roles
 * @returns React Query result.
 */
const useRoles = <ReturnedType = IRole[]>(
    configuration: UseQueryOptions<IRole[], AxiosError<void>, ReturnedType> = {}
) => {
    const url = Route.Roles;

    return useQuery<IRole[], AxiosError<void>, ReturnedType>([url], () => getRoles(url), {
        ...configuration,
    });
};

export default useRoles;
